import { IApiSettingsResponse, IRawCompanySettingsGeneral } from "@propely/propely-typings";
import { propertyFinanceKeys } from "@src/pages/Property/PropertyPage/PropertyKeyValues/PropertyKeySettings";
import { tenantFinanceKeys } from "@src/pages/Property/UnitPage/TenantKeyValues/TenantKeySettings";
import { PropertyInfoFieldGroups } from "@src/to-be-removed/LocalData/General/DataObjectHelpers/Property/InfoFields/PropertyInfoFieldGroups";
import { UnitInfoFieldGroups } from "@src/to-be-removed/LocalData/General/DataObjectHelpers/Property/InfoFields/UnitInfoFieldGroups";
import { MemberData } from "@src/to-be-removed/LocalData/Property/MemberData";
import { Role } from "@src/to-be-removed/LocalData/User/Role";

export const getMemberVisibilityType = (member: MemberData, settings: IRawCompanySettingsGeneral | undefined) => {
  const rolePriority = [Role.LANDLORD, Role.ENTREPRENEUR, Role.RENTER];
  return settings?.memberVisibility?.["" + rolePriority.find((role) => member.roles.includes(role))?.id] ?? "opt-out";
};

export const isMemberVisible = (member: MemberData, settings: IRawCompanySettingsGeneral | undefined) => {
  const visibility = getMemberVisibilityType(member, settings);
  return visibility === "opt-out" ? !member.visibility.hidden : member.visibility.visible;
};

export const isFieldEnabled = (
  fieldKey: string,
  type: "unit" | "property",
  financeModuleEnabled: boolean,
  settings: IRawCompanySettingsGeneral | undefined
) => {
  // Check finance module
  if (!financeModuleEnabled && (type === "property" ? propertyFinanceKeys : tenantFinanceKeys).includes(fieldKey)) return false;

  // Check settings
  if (type === "property" && settings?.propertyFields?.[fieldKey]) {
    return settings.propertyFields[fieldKey].enabled === true;
  }
  if (type === "unit" && settings?.unitFields?.[fieldKey]) {
    return settings.unitFields[fieldKey].enabled === true;
  }

  // Check default
  if (type === "property") {
    return Object.values(PropertyInfoFieldGroups).some((group) => group.fields[fieldKey]?.defaultEnabled);
  }
  if (type === "unit") {
    return Object.values(UnitInfoFieldGroups).some((group) => group.fields[fieldKey]?.defaultEnabled);
  }
  return false;
};
